export const submitModalTranslation = {
  English: {
    submit: "Submit Feedback",
    subtitle: "You’re just one step away from finishing - thanks for sticking with us!",
    mainTitle: "Based on your feedback, would you permit us to reach out to you for more details on your experience with IT?",
    yesButton: "Yes",
    noButton: "No",
    notificationSuccess: "Feedback submitted successfully!",
    notificationError: "Failed to submit feedback. Please try again.",
    thankYouMessage: "Your feedback is successfully submitted.",
    thankYou: "Thank you for your time.",
  },
  Chinese: {
    submit: "提交反馈",
    subtitle: "您只差一步就完成了 - 感谢您的坚持！",
    mainTitle: "根据您的反馈，我们可以联系您以了解更多关于您与IT经验的详细信息吗？",
    yesButton: "是的，当然",
    noButton: "不，谢谢",
    notificationSuccess: "反馈提交成功！",
    notificationError: "提交反馈失败。请再试一次。",
    thankYouMessage: "您的反馈已成功提交。",
    thankYou: "感谢您的时间。",
  },
  Spanish: {
    submit: "Enviar comentarios",
    subtitle: "¡Está a solo un paso de finalizar, gracias por acompañarnos!",
    mainTitle: "Basándonos en sus comentarios, ¿nos permitiría ponernos en contacto con usted para obtener más detalles sobre su experiencia con TI?",
    yesButton: "Sí, claro",
    noButton: "No, tal vez más tarde",
    notificationSuccess: "¡Comentarios enviados con éxito!",
    notificationError: "Error al enviar los comentarios. Por favor, inténtelo de nuevo.",
    thankYouMessage: "¡Sus comentarios han sido enviados con éxito!",
    thankYou: "Gracias por su tiempo.",
  },
  French: {
    submit: "Soumettre des commentaires",
    subtitle: "Vous êtes sur le point de terminer - merci de rester avec nous !",
    mainTitle: "Sur la base de vos commentaires, pourriez-vous nous permettre de vous contacter pour plus de détails sur votre expérience avec l'informatique ?",
    yesButton: "Oui, bien sûr",
    noButton: "Non, peut-être plus tard",
    notificationSuccess: "Retour envoyé avec succès !",
    notificationError: "Échec de l'envoi des commentaires. Veuillez réessayer.",
    thankYouMessage: "Votre retour a été envoyé avec succès.",
    thankYou: "Merci pour votre temps.",
  },
  Dutch: {
    submit: "Feedback verzenden",
    subtitle: "Je bent nog maar één stap verwijderd - bedankt voor je geduld!",
    mainTitle: "Zou u ons op basis van uw feedback toestemming geven om contact met u op te nemen voor meer informatie over uw ervaring met IT?",
    yesButton: "Ja, zeker",
    noButton: "Nee, misschien later",
    notificationSuccess: "Feedback succesvol verzonden!",
    notificationError: "Feedback verzenden mislukt. Probeer het opnieuw.",
    thankYouMessage: "Uw feedback is succesvol verzonden.",
    thankYou: "Bedankt voor uw tijd.",
  },
  German: {
    submit: "Feedback senden",
    subtitle: "Sie sind nur noch einen Schritt vom Abschluss entfernt – danke!",
    mainTitle: "Würden Sie uns aufgrund Ihres Feedbacks erlauben, Sie zu kontaktieren, um weitere Informationen zu Ihren Erfahrungen mit IT zu erhalten?",
    yesButton: "Ja, sicher",
    noButton: "Nein, vielleicht später",
    notificationSuccess: "Feedback erfolgreich eingereicht!",
    notificationError: "Feedback konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
    thankYouMessage: "Ihr Feedback wurde erfolgreich übermittelt.",
    thankYou: "Vielen Dank für Ihre Zeit.",
  },
  Japanese: {
    submit: "フィードバックを提出する",
    subtitle: "あと一歩で完了です - ご協力ありがとうございます！",
    mainTitle: "お客様からのフィードバックに基づいて、ITに関するお客様の経験について詳細にご連絡することを許可していただけますか?",
    yesButton: "はい、もちろん",
    noButton: "いいえ、また今度",
    notificationSuccess: "フィードバックが正常に送信されました！",
    notificationError: "フィードバックの送信に失敗しました。もう一度お試しください。",
    thankYouMessage: "フィードバックが正常に送信されました。",
    thankYou: "お時間をいただきありがとうございました。",
  },
};
